import { Controller } from "@hotwired/stimulus"

// "Let them play" (PlaysController). Sent without leaving the page, so the
// room's own wire can show both keepers the dragons at play (lair_controller
// receivePlay); a reload would drop this window out of the room first.
export default class extends Controller {
  static values = { url: String }
  static targets = [ "button", "status" ]

  async play(event) {
    event.preventDefault()
    this.buttonTarget.disabled = true

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
        }
      })
      const data = await response.json()
      this.statusTarget.textContent = data.line
      if (data.outcome === "apart") this.buttonTarget.disabled = false
    } catch {
      this.statusTarget.textContent = "That did not go through. Try again."
      this.buttonTarget.disabled = false
    }
  }
}
